export default "data:image/svg+xml,sh-hl.svg"